import axios from "axios";
import {
    UTILS,
    CURRENCIES,
    BILLS_STATUS,
    PAYMENT_RATE_TYPES,
    PAYMENT_TYPES,
} from "../../endpointsConst";

const PaymentDropdowns = {};

PaymentDropdowns.getCurrencies = () => axios.get(UTILS + CURRENCIES);

PaymentDropdowns.getBillsStatuses = (lang) =>
    axios.get(UTILS + BILLS_STATUS + `?lang=${lang}`);

PaymentDropdowns.getRateTypes = () => axios.get(UTILS + PAYMENT_RATE_TYPES);

PaymentDropdowns.getPaymentTypes = (lang) =>
    axios.get(UTILS + PAYMENT_TYPES + `?lang=${lang}`);

export { PaymentDropdowns };
